<template>
  <v-footer
    id="dashboard-core-footer"
    style="
      z-index: 0;
      background-color: rgba(238, 238, 238, 1);
      position: absolute;
      bottom: 0;
      width: 100%;
    "
  >
    <!--style="display: block; position: fixed; z-index: 10; background-color: rgba(238,238,238,1)"   top: ${getTopStaticData}-->
    <div class="container-fluid">
      <v-row align="center" no-gutters>
        <v-spacer class="hidden-sm-and-down" />

        <v-col cols="12" class="text-center">
          <div class=" font-weight-light  cpyrght ">
            Developed and maintained by ME & HMD
          </div>
        </v-col>
      </v-row>
    </div>
  </v-footer>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "DashboardCoreFooter",
  created() {},
  data: () => ({
    // links: [
    //   {
    //     href: '#',
    //     text: 'Creative Tim',
    //   },
    //   {
    //     href: '#',
    //     text: 'About Us',
    //   },
    //   {
    //     href: '#',
    //     text: 'Blog',
    //   },
    //   {
    //     href: '#',
    //     text: 'Licenses',
    //   },
    // ],
    // getTopDynamicData: 10,
  }),
  computed: {
    ...mapState(["drawer"]),
    getTopStaticData() {
      return "96%";
    },
    getTopDynamicData() {
      return window.innerHeight - 30;
    },
  },
  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
  },
  watch: {
    getTopDynamicData(val) {},
  },
};
</script>
<style >
@media (max-width: 576px) {
.cpyrght {
    display: table-footer-group;
}
}
</style>
<style lang="sass">
#dashboard-core-footer
  a
    font-size: .825rem
    font-weight: 500
    text-decoration: none
    text-transform: uppercase
</style>
